import React from 'react';
import { industryContributions } from '../data/governance';
export function IndustryContributions() {
  return <ul className="grid gap-x-10 md:grid-cols-2" data-id="element-154" data-mp="3bc4jl118cxas">
      {industryContributions.map(c => <li key={c.title} className="flex flex-col border-t border-rule py-6" data-id="element-155" data-mp="3ffu51hmlyyrl">
          <p className="text-sm text-wheat-dark" data-id="element-156" data-mp="3kedsxnkrikml">{c.role}</p>
          <h3 className="mt-1 font-serif text-xl leading-snug text-forest" data-id="element-157" data-mp="3kbrjtji83x29">{c.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-charcoal" data-id="element-158" data-mp="2npfv1whpu6l7">{c.text}</p>
          <ul className="mt-auto flex flex-wrap gap-1.5 pt-4" aria-label="Years" data-id="element-159" data-mp="2rpzux7tobob1">
            {c.years.map(y => <li key={y} className="rounded bg-cream-deep px-2 py-0.5 text-xs tabular-nums text-charcoal" data-id="element-160" data-mp="2wmympjpv7j62">
                {y}
              </li>)}
          </ul>
        </li>)}
    </ul>;
}